import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ResultMethods } from '../resultMethods.types';
import { RenderedTextResult } from './textMethods.types';
import { textResultItem } from '../Results.css';
import { HeadingTextBlock } from '@/uiComposites/typography/headings';
import { stack } from '@/uiPrimitives/layout/stack';
import { TitlePrefix } from '../../_renderers/TitlePrefix';
import { position } from '@/uiPrimitives/layout/position';

export const TextResultMethods: ResultMethods<RenderedTextResult> = {
	Render: ({ result, headingLevel }) => {
		return (
			<div
				className={classes(
					textResultItem,
					stack({ rowGap: '5 | betweenParagraphs' }),
					position({ position: 'relative' }),
				)}
			>
				<TitlePrefix titlePrefix={result.titlePrefix} />
				<HeadingTextBlock headingLevel={headingLevel}>
					{result.titleText}
				</HeadingTextBlock>
				<div>{result.description}</div>
			</div>
		);
	},
};
